export const mapStateToPlaceOrderDetails = (state) => {
  const entities = state.entities;
  const shippingAddress = entities.Addresses.find(a => a.Id === entities.SelectedShippingAddressId);
  const billingAddress = (state.ui.useShippingForBilling)
    ? shippingAddress
    : entities.Addresses.find(
        address =>
          address.Id === entities.SelectedBillingAddressId
          && entities.BillingAddresses.includes(address.Id));
  return {
    SelectedShippingAddress: shippingAddress,
    SelectedBillingAddress: billingAddress,
    SelectedPayment: {
       Id: entities.SelectedPaymentOptionId,
       POValue: entities.PaymentRecord.POValue
    },
    BillingEqualsShipping: state.ui.useShippingForBilling
  };
}
